/**
 * AppShell - Main layout wrapper component
 * Provides the sidebar and main content area structure
 */

import * as React from 'react';

import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';

export interface AppShellProps {
  children: React.ReactNode;
}

export function AppShell({ children }: AppShellProps): React.ReactElement {
  return (
    <div className="flex h-screen w-full overflow-hidden bg-canvas">
      {/* Sidebar - fixed width from design tokens on desktop */}
      <aside className="hidden h-full w-sidebar flex-shrink-0 md:block">
        <Sidebar />
      </aside>

      {/* Main content area */}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        {/* Topbar - fixed height from design tokens */}
        <header className="h-topbar flex-shrink-0">
          <Topbar />
        </header>

        {/* Content area with scroll */}
        <main className="flex-1 overflow-y-auto p-4 sm:p-6 lg:p-8">
          <div className="mx-auto w-full max-w-container min-w-0">{children}</div>
        </main>
      </div>
    </div>
  );
}
